import { createSlice } from "@reduxjs/toolkit";
const initialStockChannelState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  defaultChannel: null,
  entities: [],
  storages: [],
  storagesTotalCount: 0,
  lastError: null,
  error: null,
  description: null,
  completed: false,
  message: {
    error: null,
    success: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const channelsState = createSlice({
  name: "storageChannels",
  initialState: initialStockChannelState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors[0] : action.payload.error.errors[0];
      if (error?.constructor?.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.message.error = null;
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    setDefaultChannel: (state, action) => {
      state.defaultChannel = action.payload.defaultChannel
    },
  },
});
